(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mimori-cart-gifts"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.mimoriGiftSyncInstalled) return;
  const config = document.getElementById('mimori-gift-config');
  if (!config) return;
  window.mimoriGiftSyncInstalled = true;
  const nativeFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  const productId = Number(config.dataset.productId);
  const giftId = Number(config.dataset.giftVariantId);
  let queue = Promise.resolve();
  async function sync(sections = []) {
    const response = await nativeFetch(root + 'cart.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json();
    const quantity = cart.items.filter(item => Number(item.product_id) === productId).reduce((sum, item) => sum + item.quantity, 0);
    const desired = quantity >= 3 ? 2 : quantity >= 2 ? 1 : 0;
    const gifts = cart.items.filter(item => Number(item.variant_id) === giftId);
    const current = gifts.reduce((sum, item) => sum + item.quantity, 0);
    // Shipping Protection must not remain chargeable if the main product is removed.
    const protectionLines = cart.items.filter(item => Number(item.variant_id) === 61063168000334);
    const removeProtection = quantity === 0 && protectionLines.length > 0;
    if (current === desired && gifts.length <= 1 && !removeProtection) return null;
    const updates = {};
    gifts.forEach(item => { updates[item.key] = 0; });
    if (desired) updates[gifts[0]?.key || String(giftId)] = desired;
    if (removeProtection) protectionLines.forEach(item => { updates[item.key] = 0; });
    const payload = { updates, sections_url: window.location.pathname };
    if (sections.length) payload.sections = sections.slice(0, 5);
    const updated = await nativeFetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!updated.ok) throw new Error('Gift update unavailable');
    return updated.json();
  }
  function enqueue(sections) {
    const next = queue.catch(() => {}).then(() => sync(sections));
    queue = next;
    return next;
  }
  window.fetch = async function(input, options) {
    const response = await nativeFetch(input, options);
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.href);
    const method = (options?.method || input?.method || 'GET').toUpperCase();
    if (url.origin !== window.location.origin || method !== 'POST' || !/\/cart\/(add|change|update|clear)(?:\.js)?$/.test(url.pathname) || !response.ok) return response;
    try {
      const original = await response.clone().json();
      const updated = await enqueue(Object.keys(original.sections || {}));
      if (!updated) return response;
      const isAdd = /\/add(?:\.js)?$/.test(url.pathname);
      const result = isAdd ? { ...original, sections: updated.sections || original.sections } : { ...updated, sections: updated.sections || original.sections };
      const headers = new Headers(response.headers);
      headers.delete('content-length');
      headers.delete('content-encoding');
      headers.set('Content-Type', 'application/json');
      return new Response(JSON.stringify(result), { status: response.status, statusText: response.statusText, headers });
    } catch {
      return response;
    }
  };
  async function refresh() {
    try {
      const updated = await enqueue(['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer']);
      if (!updated?.sections) return;
      for (const [id, html] of Object.entries(updated.sections)) {
        if (!html) continue;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        if (id === 'cart-drawer') {
          const current = document.getElementById('CartDrawer');
          const replacement = parsed.getElementById('CartDrawer');
          if (current && replacement) current.innerHTML = replacement.innerHTML;
        } else {
          const current = document.getElementById('shopify-section-' + id) || document.getElementById(id);
          const replacement = parsed.getElementById(current?.id);
          if (current && replacement) current.innerHTML = replacement.innerHTML;
        }
      }
    } catch {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
})();
  } catch(e) { console.error(e); }
})();

})();
